import { API_BASE_URL } from '../../config/api';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Politic = () => {
  const { i18n } = useTranslation();
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/privacy/api/latest/`, {
      headers: {
        'Accept-Language': i18n.language // Передаем текущий язык в заголовке
      }
    })
      .then(response => {
        setPolicy(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Ошибка загрузки политики конфиденциальности:', error);
        setError('Не удалось загрузить данные.');
        setLoading(false);
      });
  }, [i18n.language]); // Следим за изменением языка и повторяем запрос

  if (loading) return <p>Загрузка...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="test_block">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="content main-content slim-view-port">
              <h1>{policy.title}</h1>
              <div dangerouslySetInnerHTML={{ __html: policy.content }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Politic;
